<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px;">
        <v-layout row style="padding: 0px;">
          <!-- Dialog for Add View Edit -->
          <action-dialog
            :type="dialogType"
            :title="title"
            :dialog="dialogStatus"
            @closeDialog="closeDialog"
            :loading="dialogLoading"
          >
            <v-container grid-list-xs>
              <v-layout>
                <v-flex md8 offset-md2>
                  <v-card class="elevation-7">
                    <table
                      id="viewTable"
                      v-for="item in viewItems"
                      :key="item.id"
                    >
                      <tr>
                        <td class="propertyName">Merchant Code:</td>
                        <td class="text-uppercase">
                          {{ item.sub_company.code }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Control No.:</td>
                        <td>
                          {{
                            item.card_shift_wireless === null
                              ? ""
                              : item.card_shift_wireless.control_no
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Device Code:</td>
                        <td>{{ item.device.device_serial }}</td>
                      </tr>
                      <tr>
                        <td class="propertyName">Branch:</td>
                        <td class="text-uppercase">{{ item.terminal.name }}</td>
                      </tr>
                      <tr>
                        <td class="propertyName">Date:</td>
                        <td class="text-xs-center">
                          {{ $dateFormat(item.transaction_date, "YYYY-MM-DD") }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Time:</td>
                        <td class="text-xs-center">
                          {{ $dateFormat(item.transaction_date, "HH:mm:ss") }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">TRX #:</td>
                        <td class="text-uppercase">
                          {{ item.transaction_no }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Trace #:</td>
                        <td class="text-uppercase">{{ item.trace_no }}</td>
                      </tr>
                      <tr>
                        <td class="propertyName">Card #:</td>
                        <td class="text-uppercase">{{ item.card_no }}</td>
                      </tr>
                      <tr>
                        <td class="propertyName">Type:</td>
                        <td class="text-uppercase">
                          {{ item.transaction_type.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Previous Balance:</td>
                        <td class="text-xs-right">
                          {{ $amountInPeso(item.previous_balance) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Amount:</td>
                        <td class="text-xs-right">
                          {{ $amountInPeso(item.card_amount) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Remaining Balance:</td>
                        <td class="text-xs-right">
                          {{ $amountInPeso(item.remaining_balance) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="propertyName">Cashier Name:</td>
                        <td class="text-uppercase">
                          {{
                            item.user
                              ? item.user.first_name + " " + item.user.last_name
                              : ""
                          }}
                        </td>
                      </tr>
                    </table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </action-dialog>

          <v-flex md6>
            <v-form ref="form">
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search by Card No."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-form>
          </v-flex>

          <v-spacer></v-spacer>

          <!-- <v-btn fab dark small color="amber darken-2" @click="getData">
            <v-icon dark>play_arrow</v-icon>
          </v-btn> -->
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="$moduleAccess('download pdf')"
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadPDF"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z"
                />
              </svg>
            </v-btn>
            <span>Download PDF File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px;" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :disabled="queryParams.search ? true : false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  :disabled="queryParams.search ? true : false"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="dateToMenu"
                :close-on-content-click="false"
                v-model="dateToMenu"
                :disabled="queryParams.search ? true : false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  :disabled="queryParams.search ? true : false"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>

      <v-container fluid class="pa-2">
        <v-layout row>
          <v-flex sm4 md4 class="pl-0">
            <v-btn @click="openFilterExpansion">
              <v-icon class="mr-3">{{
                openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
              }}</v-icon>
              <span>Filter {{ title }}</span>
            </v-btn>
          </v-flex>
          <v-flex sm8 md8></v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <filter-panel :openFilter="openFilter">
        <v-flex md4>
          <v-select
            v-model="filterWirelessTransaction"
            :items="filterWirelessTransactions"
            label="Transaction Type"
            solo
            clearable
          ></v-select>
        </v-flex>
      </filter-panel>

      <bottom-scroll @on-bottom="loadMore" :debounce="200" :offset="0">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align
                ]"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.merchant ? props.item.merchant : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.control_no ? props.item.control_no : "--" }}
            </td>
            <td class="text-xs-left no-wrap">
              {{ props.item.device_serial ? props.item.device_serial : "--" }}
            </td>
            <td class="text-xs-left text-uppercase no-wrap">
              {{ props.item.terminal ? props.item.terminal : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{
                props.item.transaction_date
                  ? $dateFormat(props.item.transaction_date, "YYYY-MM-DD")
                  : "--"
              }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.transaction_date
                  ? $dateFormat(props.item.transaction_date, "HH:mm:ss")
                  : "--"
              }}
            </td>
            <td class="text-xs-left no-wrap">
              {{ props.item.transaction_no ? props.item.transaction_no : "--" }}
            </td>
            <td class="text-xs-left no-wrap">
              {{ props.item.trace_no ? props.item.trace_no : "--" }}
            </td>
            <td class="text-xs-left">
              {{ props.item.card_no ? props.item.card_no : "--" }}
            </td>
            <td class="text-xs-center text-uppercase no-wrap">
              {{ props.item.type ? props.item.type : "--" }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.previous_balance) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.card_amount) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.remaining_balance) }}
            </td>
            <td class="text-xs-left text-uppercase no-wrap">
              {{ props.item.cashier_name ? props.item.cashier_name : "--" }}
            </td>
          </template>
        </v-data-table>
      </bottom-scroll>

      <v-dialog
        v-model="mapDialog"
        max-width="87.5vw"
        @keydown.esc="mapDialog = false"
      >
        <v-card>
          <official-map
            :center="center"
            :zoom="zoom"
            ref="map"
            v-bind:style="{ height: heightMap + 'vh', width: widthMap + 'vw' }"
          ></official-map>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import OfficialMap from "@/components/OfficialMap";
import XLSX from "xlsx";
import JsPdf from "jspdf";
import "jspdf-autotable";

export default {
  components: {
    OfficialMap
  },
  data() {
    return {
      clockMode: "",
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      heightMap: "",
      widthMap: "",
      mapDialog: false,
      center: { lat: 14.4793, lng: 121.0198 },
      zoom: 20,
      title: "Final Transaction",
      items: [],
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Merchant Code",
          align: "left",
          value: "merchant_code",
          sortable: false
        },
        {
          text: "Control No.",
          align: "left",
          value: "control_no",
          sortable: false
        },
        {
          text: "Device Code",
          align: "center",
          value: "device_code",
          sortable: false
        },
        {
          text: "Branch",
          align: "left",
          value: "branch",
          sortable: false
        },
        {
          text: "Date",
          align: "center",
          value: "transaction_date",
          sortable: true
        },
        {
          text: "Time",
          align: "center",
          value: "transaction_date",
          sortable: true
        },
        {
          text: "TRX #",
          align: "center",
          value: "transaction_no",
          sortable: false
        },
        {
          text: "Trace #",
          align: "center",
          value: "trace_no",
          sortable: false
        },
        {
          text: "Card #",
          align: "center",
          value: "card_no",
          sortable: false
        },
        {
          text: "Type",
          align: "center",
          value: "transaction_type_id",
          sortable: false
        },
        {
          text: "Previous Balance",
          align: "right",
          value: "previous_balance",
          sortable: false
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: false
        },
        {
          text: "Remaining Balance",
          align: "right",
          value: "remaining_balance",
          sortable: false
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false
        }
      ],
      filterWirelessTransactions: [],
      filterWirelessTransaction: null,
      queryParams: {
        search: null,
        offset: 0,
        limit: 300,
        transaction_type: null
      },
      totalItems: 0,
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      date_from: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      date_to: this.$dateFormat(new Date(), "YYYY-MM-DD")
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {
    filterWirelessTransaction: async function() {
      this.resetTable();
      if (
        this.filterWirelessTransaction !== null &&
        this.filterWirelessTransaction !== undefined &&
        this.filterWirelessTransaction !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.transaction_type = this.filterWirelessTransaction;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.transaction_type = null;
      }
      this.getData();
    }
  },
  created: async function() {
    this.queryParams.date_from = this.$dateFormat(new Date(), "YYYY-MM-DD");
    this.queryParams.date_to = this.$dateFormat(new Date(), "YYYY-MM-DD");

    this.getData();
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      }
    },
    dateFrom: {
      get() {
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.date_from = value;

        this.getData();
      }
    },
    dateTo: {
      get() {
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;

        this.getData();
      }
    }
  },
  methods: {
    search(data) {
      this.resetTable();
      this.queryParams.search = data;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;

      this.getData();
    },
    async getData() {
      this.$store.dispatch("startLoading");

      try {
        const response = (await Services.getFinalTransactions(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data);

        // Assign Total number of data
        this.totalItems = response.count;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection"
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    async setFilterWirelessTransactions() {
      this.filterWirelessTransactions = [];
      const items = (await Services.getTransactionTypes({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].code
        };
        this.filterWirelessTransactions.push(data);
      }
    },

    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterWirelessTransactions();
    },

    async initMap(data) {
      this.heightMap = 80;
      this.widthMap = 87.5;
      this.center = { lat: data.lat, lng: data.long };
      await this.$refs.map.initializeMap();
      await this.$refs.map.addMarker(data);
    },
    refreshData() {
      this.resetTable();

      this.getData();
    },
    resetTable() {
      this.items = [];
      this.queryParams.limit = 300;
      this.queryParams.offset = 0;
    },
    loadMore() {
      if (this.queryParams.offset >= this.totalItems) return;

      this.queryParams.offset = this.items.length;
      this.queryParams.limit = 300;

      this.getData();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let items = [];

      let params = this.queryParams;

      params.limit = null;
      params.offset = null;

      try {
        let response = (await Services.getFinalTransactions(params)).data;

        // Assign the reponse data to items to be display on table
        items = response.data;

        this.$store.dispatch("endLoading");
      } catch (error) {
        this.$store.dispatch("endLoading");

        return this.$infoBar({
          type: "error",
          text: "No network or server connection"
        });
      }

      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      //   header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 25 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      // theItem.push(this.items[e].
      // this.$dateFormat
      for (let e = 0; e < items.length; e++) {
        const theItem = [];

        theItem.push(
          items[e].merchant ? items[e].merchant.toUpperCase() : "--"
        );
        theItem.push(items[e].control_no ? items[e].control_no : "--");
        theItem.push(items[e].device_serial ? items[e].device_serial : "--");
        theItem.push(
          items[e].terminal ? items[e].terminal.toUpperCase() : "--"
        );
        theItem.push(
          items[e].transaction_date
            ? this.$dateFormat(items[e].transaction_date, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].transaction_date
            ? this.$dateFormat(items[e].transaction_date, "HH:mm")
            : "--"
        );
        theItem.push(items[e].transaction_no ? items[e].transaction_no : "--");
        theItem.push(items[e].trace_no ? items[e].trace_no : "--");
        theItem.push(items[e].card_no ? items[e].card_no : "--");
        theItem.push(items[e].type ? items[e].type.toUpperCase() : "--");
        theItem.push(items[e].previous_balance);
        theItem.push(items[e].card_amount);
        theItem.push(items[e].remaining_balance);
        theItem.push(
          items[e].cashier_name ? items[e].cashier_name.toUpperCase() : "--"
        );

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports"
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"]
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf"
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async downloadPDF() {
      this.$store.dispatch("startLoading");

      this.items = [];

      const response2 = (await Services.getTransactionWireless({
        offset: 0,
        transaction_type_id: null,
        date_from: this.dateFrom + " " + this.timeFrom + ":00",
        date_to: this.dateTo + " " + this.timeTo + ":59"
      })).data;

      this.items = response2.data;

      var doc = new JsPdf("l", "pt", "a4");

      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text(this.title + " Report", 410, 30, { align: "center" });

      let headers = [
        [
          "Merchant Code",
          "Control No.",
          "Device Code",
          "Branch",
          "Date",
          "Time",
          "TRX #",
          "Trace #",
          "Card #",
          "Type",
          "Previous Balance",
          "Amount",
          "Remaining Balance",
          "Cashier Name"
        ]
      ];

      let data = [];

      this.items.forEach(item => {
        let theData = [
          item.sub_company.code,
          item.card_shift_wireless === null
            ? ""
            : item.card_shift_wireless.control_no,
          item.device.device_serial,
          item.terminal.name.toUpperCase(),
          this.$dateFormat(item.transaction_date, "YYYY-MM-DD"),
          this.$dateFormat(item.transaction_date, "HH:mm"),
          item.transaction_no,
          item.trace_no,
          item.card_no,
          item.transaction_type.name.toUpperCase(),
          this.numberWithCommas(item.previous_balance.toFixed(2)),
          this.numberWithCommas(item.card_amount.toFixed(2)),
          this.numberWithCommas(item.remaining_balance.toFixed(2)),
          (item.user.first_name === undefined || item.user.first_name === null
            ? ""
            : item.user.first_name) +
            " " +
            (item.user.middle_name === undefined ||
            item.user.middle_name === null
              ? ""
              : item.user.middle_name) +
            " " +
            (item.user.last_name === undefined || item.user.last_name === null
              ? ""
              : item.user.last_name)
        ];
        data.push(theData);
      });

      doc.autoTable({
        didParseCell: data => {
          let col = data.column.index;
          if (
            col === 3 ||
            col === 4 ||
            col === 8 ||
            col === "3" ||
            col === "4" ||
            col === "8"
          ) {
            data.table.styles.headStyles.halign = "center";
          } else if (
            col === 9 ||
            col === 10 ||
            col === 11 ||
            col === "9" ||
            col === "10" ||
            col === "11"
          ) {
            data.table.styles.headStyles.halign = "right";
          } else {
            data.table.styles.headStyles.halign = "left";
          }
        },
        head: headers,
        body: data,
        startY: 60,
        margin: {
          left: 10
        },
        theme: "grid",
        tableWidth: 832,
        cellWidth: "wrap",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1
        },
        showHead: "everyPage",
        tableLineColor: 200,
        tableLineWidth: 0,
        columnStyles: {
          0: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
          2: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          3: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          4: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center"
          },
          5: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center"
          },
          6: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          7: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          8: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          9: {
            cellWidth: "auto",
            lineColor: "black",
            halign: "center",
            textColor: [0, 0, 0]
          },
          10: {
            cellWidth: "auto",
            halign: "right",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          11: {
            cellWidth: "auto",
            halign: "right",
            lineColor: "black",
            textColor: [0, 0, 0]
          },
          12: {
            cellWidth: "auto",
            lineColor: "black",
            halign: "right",
            textColor: [0, 0, 0]
          },
          13: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0]
          }
        },
        styles: {
          overflow: "linebreak",
          cellWidth: "wrap",
          fontSize: 7
        }
      });

      let pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i < pageCount; i++) {
        doc.setFontType("normal");
        doc.setFontSize(10);
        doc.setPage(i);
        doc.text(
          395,
          580,
          "Page" +
            " " +
            doc.internal.getCurrentPageInfo().pageNumber +
            " " +
            "of" +
            " " +
            pageCount
        );
      }
      doc.save(this.title + ".pdf");

      this.$store.dispatch("endLoading");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.form {
  padding: 0px 5px 10px 5px;
  border: 2px solid gray;
  border-radius: 5px;
}
.form:hover {
  border: 2px solid black;
}
#styled-input {
  height: 10px !important;
  font-size: 10pt !important;
}
</style>
